import styled from '@emotion/styled'
import React from 'react'
import { breakpoint } from '../../__styling/style-functions/breakpoint'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export interface TheWestLogoProps {
    className?: string
    logoWidth?: number
    logoHeight?: number | undefined
}

const StyledImg = styled('img')<TheWestLogoProps>({}, (props) => ({
    // IE11 and some android browsers requires a height and width to render correctly
    width: calcRem(210),
    display: 'block',
    margin: '0.5rem 0 0 0',
    [breakpoint('sm')]: {
        width: props.logoWidth ? calcRem(props.logoWidth) : undefined,
        margin: '1rem 0',
    },
}))

const queensLegacyImg = require('./images/queensLegacyLogo.png')

export const QueensLegacyLogo: React.FC<TheWestLogoProps> = ({
    className,
    logoWidth,
}) => (
    <StyledImg
        className={className ? className : undefined}
        src={queensLegacyImg}
        logoWidth={logoWidth}
        alt="The Queens Legacy Logo"
    />
)
QueensLegacyLogo.displayName = 'QueensLegacyLogo'
